import { css } from "@emotion/react";

export const page = css`
  min-height: 100vh;
  background: #f5f5f3;
  padding: 40px 24px 72px;
`;

export const shell = css`
  max-width: 1240px;
  margin: 0 auto;
`;

export const loginCard = css`
  max-width: 420px;
  margin: 80px auto;
`;

export const header = css`
  display: flex;
  align-items: flex-end;
  justify-content: space-between;
  gap: 24px;
  margin-bottom: 28px;

  @media (max-width: 720px) {
    align-items: flex-start;
    flex-direction: column;
  }
`;

export const kicker = css`
  margin: 0 0 4px;
  font-size: 12px;
  letter-spacing: 0;
  text-transform: uppercase;
  color: rgba(31, 31, 31, 0.62);
`;

export const title = css`
  margin: 0;
  font-family: ui-serif, Georgia, "Times New Roman", serif;
  font-size: 34px;
  font-weight: 300;
  color: #1f1f1f;
`;

export const nav = css`
  display: flex;
  align-items: center;
  flex-wrap: wrap;
  gap: 10px;
`;

export const navLink = (active: boolean) => css`
  min-height: 32px;
  padding: 6px 12px;
  border: 1px solid ${active ? "#1f1f1f" : "rgba(31, 31, 31, 0.18)"};
  background: ${active ? "#1f1f1f" : "transparent"};
  color: ${active ? "#fff" : "#1f1f1f"};
  text-decoration: none;
  font-size: 14px;

  &:hover {
    color: ${active ? "#fff" : "#1f1f1f"};
    border-color: #1f1f1f;
  }
`;

export const panel = css`
  border-radius: 8px;
`;

export const grid = css`
  display: grid;
  grid-template-columns: repeat(4, minmax(0, 1fr));
  gap: 24px;

  @media (max-width: 1120px) {
    grid-template-columns: repeat(3, minmax(0, 1fr));
  }

  @media (max-width: 820px) {
    grid-template-columns: repeat(2, minmax(0, 1fr));
  }

  @media (max-width: 560px) {
    grid-template-columns: 1fr;
  }
`;

export const card = css`
  border: 1px solid rgba(31, 31, 31, 0.14);
  background: #fff;
`;

export const imageWrap = css`
  position: relative;
  width: 100%;
  aspect-ratio: 1 / 1;
  overflow: hidden;
  background: #ece8e1;
`;

export const badge = css`
  position: absolute;
  top: 10px;
  right: 0;
  z-index: 1;
  color: #1f1f1f;
  font-size: 10px;
  padding: 3px 8px;
  background: #f5f5f3;
`;

export const image = css`
  width: 100%;
  height: 100%;
  object-fit: cover;
`;

export const noImage = css`
  width: 100%;
  height: 100%;
  display: flex;
  align-items: center;
  justify-content: center;
  color: #888;
`;

export const cardBody = css`
  min-height: 150px;
  padding: 16px;
  display: flex;
  flex-direction: column;
  justify-content: space-between;
  gap: 16px;
`;

export const productName = css`
  margin: 0 0 8px;
  font-size: 18px;
  line-height: 1.25;
  color: #1f1f1f;
`;

export const productMeta = css`
  margin: 0;
  color: rgba(31, 31, 31, 0.62);
`;

export const actions = css`
  display: flex;
  flex-wrap: wrap;
  gap: 8px;
`;
